module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ko8gOC/tc-custom/9781614236269.jpg?1720272536254",
      "alt": "This image is the cover for the book Murder and Mayhem in the Napa Valley, Murder & Mayhem"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder and Mayhem in the Napa Valley, Murder & Mayhem\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The picturesque vineyards of California's Napa Valley, one of the world's premier tourist destinations, disguise a tangled history of lawlessness, depravity and frontier justice. Some crimes were committed over debts, some for retribution and others in the name of love. Famed photographer Eadweard Muybridge killed a man for seducing his wife but was acquitted. Other criminals were not so lucky and met the gallows, like murderer William Roe, the state's final public execution. From the Pomo massacre--the first criminal case heard by the California Supreme Court--to the cold cases that continue to haunt the region, Napa Police Detective Todd Shulman decants the crimes of the Napa Valley, memorializing the victims and honoring the efforts of local law enforcement.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Todd L. Shulman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Todd L. Shulman works in law enforcement at the Napa Police Department. He has held positions within the department as a detective, training officer, crime scene specialist, corporal, and cold case investigator. Shulman formed the non-profit Napa Police Historical Society in 2006. John Boessenecker is the award-winning author of numerous books on crime and law enforcement in frontier California")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0